import React from "react";

const EmptyState = ({ searchTerm, message }) => {
  return (
    <div className="col-span-full flex flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 py-16 text-center">
      <svg
        className="mb-3 h-16 w-16 text-gray-400"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        ></path>
      </svg>
      <p className="mb-1 text-lg font-medium text-gray-500">
        Aucun auteur trouvé
      </p>
      <p className="text-sm text-gray-400">{message}</p>
    </div>
  );
};

export default EmptyState;
